import { render, staticRenderFns } from "./transLang.vue?vue&type=template&id=69eeb3ca&scoped=true"
import script from "./transLang.vue?vue&type=script&lang=js"
export * from "./transLang.vue?vue&type=script&lang=js"
import style0 from "./transLang.vue?vue&type=style&index=0&id=69eeb3ca&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69eeb3ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69eeb3ca')) {
      api.createRecord('69eeb3ca', component.options)
    } else {
      api.reload('69eeb3ca', component.options)
    }
    module.hot.accept("./transLang.vue?vue&type=template&id=69eeb3ca&scoped=true", function () {
      api.rerender('69eeb3ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/homeHead/transLang.vue"
export default component.exports